import { FileSharer } from "@byteowls/capacitor-filesharer";
import { Capacitor } from "@capacitor/core";
import { toErrorMessage } from "@clipboard-health/util-ts";
import { isAndroidPlatform } from "@src/appV2/lib";
import { APP_V2_APP_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { blobToBase64 } from "@src/appV2/lib/files/utils";

export async function sharePdf(params: {
  pdfBlob: Blob;
  workerId: string;
  qualification: string;
  firstName: string;
  lastName: string;
  licenseNumber: string;
}) {
  const { pdfBlob, workerId, qualification, firstName, lastName, licenseNumber } = params;

  if (Capacitor.getPlatform() === "web") {
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line n/no-unsupported-features/node-builtins
    const url = URL.createObjectURL(pdfBlob);
    const newWindow = window.open(url, "_blank");

    if (newWindow) {
      newWindow.focus();
      logEvent(APP_V2_APP_EVENTS.INDEPENDENT_CONTRACTOR_BADGE_SHARED, {
        workerId,
        qualification,
      });

      return;
    }

    throw new Error("Failed to open badge PDF in a new tab. Please check your browser settings.");
  }

  // Convert Blob to base64 for native sharing
  const base64DataUrl = await blobToBase64(pdfBlob);
  const base64Data = base64DataUrl.split(",")[1]; // Remove the data URL prefix

  const fullName = `${firstName} ${lastName}`.trim().replace(/\s+/g, "_");
  // Replace all special characters with _
  const fileName = `${fullName}_${qualification}_${licenseNumber}_badge`.replace(/\W/g, "_");

  try {
    await FileSharer.share({
      filename: `${fileName}.pdf`,
      base64Data,
      contentType: "application/pdf",
    });
  } catch (error: unknown) {
    // Suppress "USER_CANCELLED" error on Android as it's being thrown even when the user shares successfully
    if (!(isAndroidPlatform() && toErrorMessage(error) === "USER_CANCELLED")) {
      throw error;
    }
  }

  logEvent(APP_V2_APP_EVENTS.INDEPENDENT_CONTRACTOR_BADGE_SHARED, {
    workerId,
    qualification,
  });
}
